///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.abc_item_pricing = abcsetup.abc_item_pricing || {};
abcsetup.abc_item_pricing.index = abcsetup.abc_item_pricing.index || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.abc_item_pricing.index = {
    init() {
        abcsetup.setTitle('Item Pricing Lookup');

        $(document).on('click', '#brandedpricing-table tbody tr', function (event) {
            $("#brandedpricing-table tbody tr").removeClass('row_selected');
            $(this).addClass('row_selected');
        });
    },
    tableDrawCallback: function(table){
        $('#' + table + ' tr').each(function () {
            if ($(this).find('td:eq(2)').find('.locked').length) {
                $(this).addClass('locked');
            }
        });
    },
}
